/**
 * @generated SignedSource<<1b2180b786c64eff121e846bd1dd9176>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NewProfileSidebar_userProfile$data = {
  readonly __typename: "UserProfile";
  readonly analyticsId: number;
  readonly bio: string | null;
  readonly externalLinks: {
    readonly count: number;
  };
  readonly hasActivePortfolioSubscription: boolean;
  readonly hasCompletedClientOnboarding: boolean;
  readonly hasCompletedIndyOnboarding: boolean;
  readonly hasPublishedPortfolio: boolean;
  readonly id: string;
  readonly isQuickResponder: boolean;
  readonly isRemovedFromClientWorkspace: boolean;
  readonly location: string | null;
  readonly organization: {
    readonly id: string;
  } | null;
  readonly tags: ReadonlyArray<{
    readonly __typename: string;
  }>;
  readonly visibleUserReviewSummary: {
    readonly count: number;
  } | null;
  readonly visitorCanEdit: boolean;
  readonly workPreferences: {
    readonly languages: ReadonlyArray<{
      readonly __typename: "LanguageProficiency";
    }>;
    readonly minimumHourlyRate: number | null;
    readonly timezoneOffsetTolerance: number | null;
    readonly timezonePrimaryUtcOffset: number | null;
  };
  readonly " $fragmentSpreads": FragmentRefs<"BioV2_userProfile" | "FullName_name" | "HiringAsAnIndividual_userProfile" | "IncompleteProfileBadge_profile" | "InquireAndSave_userProfile" | "Languages_userProfile" | "Links_userProfile" | "Location_userProfile" | "Organization_userProfile" | "PortfolioAndRecommendationsDataWrapper_userProfile" | "ProfileSidebarAvatarV2_userProfile" | "Rate_userProfile" | "SkillsAndTools_userProfile" | "Timezone_userProfile" | "useBadges_userProfile">;
  readonly " $fragmentType": "NewProfileSidebar_userProfile";
};
export type NewProfileSidebar_userProfile$key = {
  readonly " $data"?: NewProfileSidebar_userProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"NewProfileSidebar_userProfile">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }
],
v3 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": true,
      "kind": "LocalArgument",
      "name": "showPortfolioAndRecommendationsSection"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "NewProfileSidebar_userProfile",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "analyticsId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasCompletedClientOnboarding",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isRemovedFromClientWorkspace",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasCompletedIndyOnboarding",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasActivePortfolioSubscription",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasPublishedPortfolio",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isQuickResponder",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "VisibleUserReviewSummary",
      "kind": "LinkedField",
      "name": "visibleUserReviewSummary",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserProfileExternalLinkConnection",
      "kind": "LinkedField",
      "name": "externalLinks",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "tagContexts",
          "value": [
            "WORK_PREFERENCE",
            "PROFILE"
          ]
        },
        {
          "kind": "Literal",
          "name": "tagTypes",
          "value": [
            "ROLE_TAG",
            "TOOL_TAG"
          ]
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "tags",
      "plural": true,
      "selections": (v3/*: any*/),
      "storageKey": "tags(tagContexts:[\"WORK_PREFERENCE\",\"PROFILE\"],tagTypes:[\"ROLE_TAG\",\"TOOL_TAG\"])"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bio",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "location",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WorkPreferences",
      "kind": "LinkedField",
      "name": "workPreferences",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minimumHourlyRate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timezonePrimaryUtcOffset",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timezoneOffsetTolerance",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LanguageProficiency",
          "kind": "LinkedField",
          "name": "languages",
          "plural": true,
          "selections": (v3/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "IncompleteProfileBadge_profile"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FullName_name"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InquireAndSave_userProfile"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BioV2_userProfile"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Location_userProfile"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProfileSidebarAvatarV2_userProfile"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Links_userProfile"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Organization_userProfile"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HiringAsAnIndividual_userProfile"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Rate_userProfile"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Languages_userProfile"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SkillsAndTools_userProfile"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Timezone_userProfile"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useBadges_userProfile"
    },
    {
      "condition": "showPortfolioAndRecommendationsSection",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PortfolioAndRecommendationsDataWrapper_userProfile"
        }
      ]
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};
})();

(node as any).hash = "83976c0fb86b730eabf12c2a83753f38";

export default node;
